export default __webpack_public_path__ + "static/media/Counter.b82afea3.png";